"use client"

import Image from "next/image";
import { useEffect, useState, useRef } from "react";

const ShowImageOnViewPort = (props) => {
  const { priority, ...rest } = props;

  // Default behavior is unchanged for every existing caller: lazy-load.
  // Callers can opt a specific image (e.g. the first above-the-fold card)
  // out of lazy-loading by explicitly passing `priority`.
  if (priority) {
    return <Image id="readystep-img" {...rest} priority />;
  }

  return <Image id="readystep-img" { ...rest } loading="lazy"/>;
};

export default ShowImageOnViewPort;
